<img [src]="source" alt="Image" class="responsive">
